import React, { ReactNode } from 'react';
import { IControlProps, IPartialFormGroup } from '@controls/types';
import FormControl from '../FormControl';
import Textarea, { ITextareaProps } from '@atoms/Textarea';
import { useHookFormController } from '@hooks/useHookFormController';

export type ITextareaBase64ControlProps = ITextareaProps &
    IControlProps & {
        formGroupProps?: IPartialFormGroup;
        label?: ReactNode;
        tooltip?: ReactNode;
        required?: boolean;
    };

const TextareaBase64Control = ({
    name,
    rules,
    defaultValue,
    control,
    formState,
    shouldUnregister,
    label,
    tooltip,
    required,
    formGroupProps,
    onValueChange,
    ...props
}: ITextareaBase64ControlProps) => {
    const Controller = useHookFormController();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field: { onChange, ref, value, ...fieldProps } }) => (
                <FormControl
                    name={name}
                    label={label}
                    tooltip={tooltip}
                    required={required}
                    formState={formState}
                    {...formGroupProps}
                >
                    <Textarea
                        {...fieldProps}
                        {...props}
                        value={value ? decodeURIComponent(escape(atob(value))) : ''}
                        onValueChange={(val) => {
                            let encodedVal = btoa(unescape(encodeURIComponent(val)));
                            onChange(encodedVal);
                            onValueChange && onValueChange(encodedVal);
                        }}
                    />
                </FormControl>
            )}
        />
    );
};

export default TextareaBase64Control;
